module.exports = __webpack_public_path__ + "img/archive.ace4fa4f.svg";